module.exports = {

  // Theme-specific spacing
  'cta-space': '2.5em',
  'heading-space': '2em', // relative to body type below heading
  'header-height-mobile': '44px',
  'header-height-desktop': '72px',

  // General spacing
  'thin': '.125rem',
  'grid-gap': '2px',
  '0': '0',
  '1': '0.25rem',
  '2': '0.5rem',
  '3': '0.75rem',
  '4': '1rem',
  '5': '1.25rem',
  '6': '1.5rem',
  '7': '1.75rem',
  '8': '2rem',
  '9': '2.25rem',
  '10': '2.5rem',
  '11': '2.75rem',
  '12': '3rem',
  '14': '3.5rem',
  '16': '4rem',
  '18': '4.5rem',
  '20': '5rem',
  '25': '6.25rem',
  '30': '7.5rem',
  '40': '10rem',
  '44': '11rem',
  '50': '12.5rem',
  // Relative to current font size
  '3rel': '0.75em',
  '6rel': '1.5em',
  // fractions
  '2/7': 'calc(100% * (2 / 7))',
  // percents
  '0-per': '0%',
  '5-per': '5%',
  '10-per': '10%',
  '15-per': '15%',
  '20-per': '20%',
  '25-per': '25%',
  '30-per': '30%',
  '35-per': '35%',
  '40-per': '40%',
  '50-per': '50%',
  '60-per': '60%',
  '70-per': '70%',
  '80-per': '80%',
  '90-per': '90%',
};
